import { MoveGenerator } from '../../jscaip/AI/AI';
import { DvonnMove } from './DvonnMove';
import { DvonnRules } from './DvonnRules';
export class DvonnMoveGenerator extends MoveGenerator {
    getListMoves(node, _config) {
        const lastMove = node.previousMove;
        const state = node.gameState;
        const moves = [];
        // For each movable piece, look at its possible targets
        DvonnRules.getMovablePieces(state).forEach((start) => {
            return DvonnRules.pieceTargets(state, start).forEach((end) => {
                const move = DvonnMove.from(start, end).get();
                // the move should be legal by construction, hence we don't check it
                moves.push(move);
            });
        });
        if (moves.length === 0 && lastMove.equalsValue(DvonnMove.PASS) === false) {
            moves.push(DvonnMove.PASS);
        }
        return moves;
    }
}
